var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSyllabus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:#f1f1f1;stroke-width:3px;fill:url(#a);}.b{fill:#bc5801;}.c{fill:#fdb153;}.d{fill:#fff;}.e{fill:#86acf5;}.f{fill:#f45e29;}.g{fill:#4482ff;}.h{stroke:none;}.i{fill:none;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.197,
    y1: 0.133,
    x2: 0.889,
    y2: 1.036,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4482ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#4482ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0741b6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -944)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(20 944)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 45,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 45,
    cy: 45,
    r: 43.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.001 967)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15,
    height: 3,
    rx: 1.5,
    transform: "translate(14.43 36.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13,
    height: 4,
    rx: 2,
    transform: "translate(15.43 39.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.664,8.6A11.8,11.8,0,0,1,29.256,7.84c8.76,6.292,2.709,17.132,2.709,17.132l-2.647,4.849L28.447,32.5v3.368H15.353L15,30.956l-4.535-8.1-.995-4.184.463-3.694,1.337-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M46.169,46.614c.016-1.447,1.39-4.386,3.587-7.671a12.748,12.748,0,0,0,2.209-6.414c.011-.212.016-.428.016-.642a12.846,12.846,0,0,0-6.766-11.28,18.736,18.736,0,0,1,.522,1.929,11.43,11.43,0,0,1,4.876,9.351q0,.288-.014.573a11.372,11.372,0,0,1-1.98,5.722c-1.248,1.866-3.792,6-3.818,8.416-.006.562-.026,1.257-.008,2.178H41.041V43.991h1.2a.684.684,0,0,0,0-1.368h-6.5a.684.684,0,1,0,0,1.368h1.2v4.786H33.175a15.833,15.833,0,0,0-.68-4.636c-.918-2.711-3.046-4.825-4.072-7.471a11.254,11.254,0,0,1-1.053-5.126,11.493,11.493,0,0,1,4.867-8.989,18.736,18.736,0,0,1,.519-1.925A12.942,12.942,0,0,0,26,31.5a12.549,12.549,0,0,0,1.162,5.7,21.147,21.147,0,0,0,2.072,3.738A16.832,16.832,0,0,1,31.2,44.58a14.686,14.686,0,0,1,.609,4.475,2.051,2.051,0,0,0-1.025,1.774v.684a2.053,2.053,0,0,0,1.379,1.936c0,.039-.012.076-.012.115v1.709A2.054,2.054,0,0,0,34.2,57.324h9.573a2.054,2.054,0,0,0,2.051-2.051V53.564c0-.04-.008-.077-.012-.115a2.053,2.053,0,0,0,1.379-1.936v-.684a2.051,2.051,0,0,0-1.027-1.774c-.023-.836-.013-1.5,0-2.039C46.166,46.874,46.168,46.741,46.169,46.614Zm-7.863-2.624h1.368v4.786H38.306ZM44.46,55.273a.684.684,0,0,1-.684.684H34.2a.684.684,0,0,1-.684-.684V53.564H44.46Zm1.368-3.761a.684.684,0,0,1-.684.684H32.836a.684.684,0,0,1-.684-.684v-.684a.684.684,0,0,1,.684-.684H45.144a.684.684,0,0,1,.684.684Z",
    transform: "translate(-17.109 -13.562)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(0.43 0.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(34.43 34.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(36.43 0.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(2.43 32.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M98.749,91.243a4.755,4.755,0,0,0-2.607.778l-4.674-5.327c-.252.487-.466.937-.642,1.342l4.288,4.888a4.782,4.782,0,1,0,3.635-1.68Zm0,8.205a3.419,3.419,0,1,1,3.419-3.419A3.419,3.419,0,0,1,98.749,99.448Z",
    transform: "translate(-59.774 -57.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4.786,9.589a4.761,4.761,0,0,0,3.14-1.183L10.1,10.274q.394-.561.84-1.082L8.819,7.37A4.782,4.782,0,1,0,4.786,9.589Zm0-8.205A3.419,3.419,0,1,1,1.367,4.8,3.419,3.419,0,0,1,4.786,1.384Z",
    transform: "translate(0 -0.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M102.827,0a4.094,4.094,0,0,0-3.5,6.229L95.983,9.122q.446.519.842,1.08l3.392-2.936A4.1,4.1,0,1,0,102.827,0Zm0,6.838A2.735,2.735,0,1,1,105.562,4.1,2.735,2.735,0,0,1,102.827,6.838Z",
    transform: "translate(-63.168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M16.1,85.359l-2.854,2.98a4.144,4.144,0,1,0,.985.949L16.8,86.6C16.6,86.19,16.358,85.777,16.1,85.359Zm-5.157,9.108a2.735,2.735,0,1,1,2.735-2.735A2.735,2.735,0,0,1,10.943,94.467Z",
    transform: "translate(-4.448 -56.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M17.483,8.734l.94-3.266,1.605-2.3,1.9-2.18,1.628,1.869,1.51,2.278,1.089,2.417.634,3.4.267,3.073L26.5,17.465,25.5,20.5l-.429,1.246H18.423l-1.216-4.91-.328-4.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(19.43 10.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M518.339,829.148l1.031,2.562.234,1.983-.521,2.466-.523,1.444-2.183-2.81,1.1-4.359v-1.286Z",
    transform: "translate(-490.57 -814.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M517.641,829.148l-1.031,2.562-.234,1.983.521,2.466.523,1.444,2.183-2.81-1.1-4.359v-1.286Z",
    transform: "translate(-501.571 -814.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M51.613,25.471a.684.684,0,0,0,.684-.684V22.565h.247c.17-.393.327-.78.475-1.164l1.231,1.88a.684.684,0,0,0,.572.309h0a.684.684,0,0,0,.572-.311c2.938-4.511.265-8.733-.707-10.014A17.17,17.17,0,0,0,48.936.025a.08.08,0,0,0-.115,0,17.17,17.17,0,0,0-5.753,13.242c-.972,1.281-3.645,5.5-.707,10.014a.684.684,0,0,0,1.145,0l1.231-1.88c.148.383.3.77.475,1.164h.247v2.222a.684.684,0,0,0,1.368,0V22.565h1.368v4.274a.684.684,0,0,0,1.368,0V22.565h1.368v2.222a.684.684,0,0,0,.684.684Zm2.913-9.891a6.819,6.819,0,0,1,.248,6L53.59,19.776a23.744,23.744,0,0,0,.937-4.2ZM42.981,21.587a6.762,6.762,0,0,1,.245-6.033,23.727,23.727,0,0,0,.94,4.222Zm5.955-.389H46.125C41.889,10.543,46.75,4.03,48.878,1.839c2.128,2.19,6.989,8.7,2.754,19.358Z",
    transform: "translate(-26.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M58.735,27.14a2.735,2.735,0,1,0,2.735,2.735A2.735,2.735,0,0,0,58.735,27.14Zm0,4.1A1.368,1.368,0,1,1,60.1,29.875,1.368,1.368,0,0,1,58.735,31.243Z",
    transform: "translate(-36.855 -17.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M61.735,50H59.684a.684.684,0,0,0,0,1.368h2.051a.684.684,0,1,0,0-1.368Z",
    transform: "translate(-38.829 -32.905)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSyllabus);
export default __webpack_public_path__ + "static/media/icon-syllabus.7c781ba9.svg";
export { ForwardRef as ReactComponent };